<template>
  <div class="card card-profile">
    <img
      src="../../assets/img/shapes/fondo-ontrix-horizontal.jpg"
      alt="Image placeholder"
      class="card-img-top"
    />
    <!-- <div class="row justify-content-center">
      <div class="col-4 col-lg-4 order-lg-2">
        <div class="mt-n4 mt-lg-n6 mb-4 mb-lg-0">
          <a href="javascript:;">
            <img
              src="../../assets/img/avatar.png"
              class="rounded-circle img-fluid border border-2 border-white"
            />
          </a>
        </div>
      </div>
    </div> -->
    <div class="card-body pt-0">
      <div class="text-center mt-4">
        <h5>
          <span class="font-weight-light"> {{ authStore.infoAcces.user }}</span>
        </h5>
        <div class="h6 font-weight-300">
          <i class="ni location_pin mr-2"></i> <span class="font-weight-light">{{ authStore.infoAcces.apellidos }}</span>
        </div>
        <div class="h6">
          <i class="ni business_briefcase-24 mr-2"></i><span class="font-weight-light">{{ authStore.infoAcces.email }}</span>
        </div>
        <!-- <div>
          <i class="ni education_hat mr-2"></i>University of Computer Science
        </div> -->
      </div>
    </div>
  </div>
</template>
<script setup>

import { useAuthStore } from '@/store/auth';

const authStore = useAuthStore();

</script>